import type { WardrobeItem } from '../api';

type PriceFields = Pick<WardrobeItem, 'forRent' | 'rentPrice' | 'rentPrice1' | 'forSale' | 'salePrice'>;

/** Vad en månads hyra kostar — samma regel som kassan (api/src/routes/checkout.ts). */
export function oneMonthRentPrice(item: Pick<WardrobeItem, 'rentPrice' | 'rentPrice1'>): number {
  return item.rentPrice1 ?? Math.round(item.rentPrice * 4);
}

/**
 * Lägsta belopp annonsen erbjuds för, för "Från X kr" på korten: det billigaste
 * av en månads hyra och köppriset. Längre bindning har lägre månadspris men
 * kostar mer totalt, så den räknas inte. null = inget pris, alltså bara byte.
 */
export function lowestListingPrice(item: PriceFields): number | null {
  const candidates: number[] = [];
  if (item.forRent) {
    const p = oneMonthRentPrice(item);
    if (p > 0) candidates.push(p);
  }
  if (item.forSale && item.salePrice > 0) candidates.push(item.salePrice);
  return candidates.length ? Math.min(...candidates) : null;
}
